import actions from './actions';

const { ROLES_TABLE_READ_BEGIN, ROLES_TABLE_READ_SUCCESS, ROLES_TABLE_READ_ERR } = actions;

const initialState = {
  tableData: [],
  loading: false,
  error: null,
};

const rolesTableReducer = (state = initialState, action) => {
  const { type, data, err } = action;
  switch (type) {
    case ROLES_TABLE_READ_BEGIN:
      return {
        ...initialState,
        loading: true,
      };
    case ROLES_TABLE_READ_SUCCESS:
      return {
        ...initialState,
        tableData: data,
        loading: false,
      };
    case ROLES_TABLE_READ_ERR:
      return {
        ...initialState,
        error: err,
        loading: false,
      };
    default:
      return state;
  }
};

export default rolesTableReducer;
